/**
 * Rounds a set of parts (of a whole) to whole percentages using the Largest
 * Remainder Method (Hamilton apportionment), so the results always sum to
 * exactly 100 - unlike rounding each part independently, which can drift to
 * 99 or 101 due to compounding rounding error.
 */
export function apportionToWholePercentages(parts: number[]): number[] {
  const total = parts.reduce((sum, p) => sum + Math.max(p, 0), 0);
  if (total <= 0) return parts.map(() => 0);

  const shares = parts.map(p => (Math.max(p, 0) / total) * 100);
  const floors = shares.map(Math.floor);
  const remainder = 100 - floors.reduce((sum, f) => sum + f, 0);

  const byFraction = shares
    .map((share, i) => ({ i, frac: share - floors[i] }))
    .sort((a, b) => b.frac - a.frac);

  const result = [...floors];
  for (let k = 0; k < remainder; k++) {
    result[byFraction[k].i] += 1;
  }
  return result;
}
